import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { toast } from 'react-toastify';

import { deleteBlock } from '~/api';

import Menu from '~/components/Menu';

import EditBlockDialog from './EditBlockDialog';
import NewExerciseDialog from './NewExerciseDialog';

export default function EditMenuBlock({
  anchorEl,
  setAnchorEl,
  isOpen,
  block,
  refreshBlocks,
}) {
  const [editDialogIsOpen, setEditDialogIsOpen] = useState(false);
  const [newExerciseDialogIsOpen, setNewExerciseDialogIsOpen] = useState(false);

  const handleDeleteBlock = async () => {
    try {
      await deleteBlock(block.id);
      toast.success('Bloco deletado com sucesso!');

      await refreshBlocks();
    } catch (error) {
      toast.error('Ops, não foi possivel deletar o bloco!');
    }
  };

  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <>
      <Menu
        id="edit-menu-block"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
      >
        <MenuItem onClick={() => setEditDialogIsOpen(true)}>
          Editar Dados
        </MenuItem>
        <MenuItem onClick={() => setNewExerciseDialogIsOpen(true)}>
          Adicionar Exercício
        </MenuItem>
        <MenuItem onClick={handleDeleteBlock}>Deletar Bloco</MenuItem>
      </Menu>

      <EditBlockDialog
        isOpen={editDialogIsOpen}
        setIsOpen={setEditDialogIsOpen}
        block={block}
        refreshBlocks={refreshBlocks}
      />

      <NewExerciseDialog
        isOpen={newExerciseDialogIsOpen}
        setIsOpen={setNewExerciseDialogIsOpen}
        blockId={block.id}
        orderedIndex={block.exercises.length}
        refreshBlocks={refreshBlocks}
      />
    </>
  );
}

EditMenuBlock.propTypes = {
  anchorEl: PropTypes.bool.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  block: PropTypes.object.isRequired,
  refreshBlocks: PropTypes.func.isRequired,
};
